<template>
    <div class="footer">
        <van-tabbar v-model="active">
            <van-tabbar-item icon="wap-home" to="home" >首页</van-tabbar-item>
            <van-tabbar-item icon="search" to="query">查询</van-tabbar-item>
            <van-tabbar-item icon="service" to="manage">办理</van-tabbar-item>
            <van-tabbar-item info="0"  icon="manager" to="user">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
    export default {
        name: "index",
        data() {
            return {
                active: 0,
                icon: {
                    active: '../../assets/img/home.png',
                    inactive: 'https://img.yzcdn.cn/vant/user-inactive.png'
                }
            }
        }
    }
</script>

<style scoped>

</style>
